import { ReconfirmBillingContractRequestBody } from '@boltenergy-be/shared'
import { getAxiosRequestConfigBoltBackend, newRequest } from 'utils/request.ts'
import { Methods, Response } from 'types/request.ts'
import { log } from 'utils/logging.ts'
import { Flow } from 'types/logging.ts'

/**
 * Function to reconfirm a specific billing contract
 * @param {string} contractNumber
 * @param {ReconfirmBillingContractRequestBody} body
 * @returns {Promise<Response>}
 */
export const reconfirmBillingContract = async (
  contractNumber: string,
  body: Omit<ReconfirmBillingContractRequestBody, 'lossFlow'>
): Promise<Response> => {
  const res = await newRequest(
    getAxiosRequestConfigBoltBackend(Methods.POST, `/resources/billing-contracts/${contractNumber}/reconfirm`, {
      ...body,
      lossFlow: true
    } satisfies ReconfirmBillingContractRequestBody)
  )

  if (!res.success) {
    log({
      error: res?.message || `unknown error with reconfirm for contract`,
      identifier: `[${Flow.SERVICE_CONTRACT}:reconfirm${res?.errorCode ? `:${res.errorCode}` : ''}]`,
      errorCode: res?.errorCode,
      metaData: {
        reconfirmServiceContractError: {
          contractNumber,
          body,
          res
        }
      }
    })
  }

  return res
}
